import callAPiBase from './base';

const errorsListApi = {
  get: () =>
    callAPiBase({
      endpoint: '/errorsList',
      method: 'GET',
      useToken: true,
      title: 'Get - error List',
    }),
};

export { errorsListApi };
export default errorsListApi;
